import React from "react";
import {
  CALENDER_ICON,
  NEWS_IMAGE_1,
  NEWS_IMAGE_2,
  NEWS_IMAGE_3,
} from "../../assets";
import ButtonV2 from "../../shared/components/buttonV2";

const images = [NEWS_IMAGE_1, NEWS_IMAGE_2, NEWS_IMAGE_3];
function LastestNews() {
  return (
    <div className="w-full bg-[#F7F7F7] min-h-[900px] mt-10 py-8 sm:py-10 px-4 sm:px-8 lg:px-32 flex items-center justify-start flex-col">
      <div className="flex flex-col items-center justify-center gap-y-1">
        <span className="text-[14px] sm:text-[16px] relative font-semibold pb-0.5 text-globalGreen">
          Latest News
          <div className="w-[70px] sm:w-[89px] absolute border-b-2 border-globalGreen"></div>
        </span>
        <span className="text-[24px] sm:text-[28px] lg:text-[32px] font-semibold text-black text-center">
          News & Events
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 w-full gap-4 sm:gap-6 lg:gap-7 mt-8 sm:mt-10 relative">
        {images.map((item, index) => (
          <div
            key={index}
            className="w-full relative rounded-xl border-b-[3px] border-globalGreen"
          >
            <div className="absolute m-3 sm:m-5 z-30 bg-white w-[50px] sm:w-[56px] h-[28px] sm:h-[32px] rounded-md flex items-center justify-center text-globalGreen text-xs sm:text-sm font-medium">
              News
            </div>
            <img
              src={item}
              className="w-full h-[200px] sm:h-[220px] lg:h-[250px] z-10 object-cover rounded-xl"
              alt={`News image ${index + 1}`}
            />

            <div className="z-30 !bg-white rounded-t-xl rounded-b-xl border-b-[3px] border-globalGreen flex flex-col gap-y-3 sm:gap-y-5 items-start -mt-6 sm:-mt-7 absolute px-3 sm:px-5 py-3">
              <span className="text-sm sm:text-base lg:text-lg font-semibold leading-relaxed">
                SPECIAL COURT SESSION: PRESIDENT OF ENUGU CUSTOMARY COURT OF
                APPEAL HONOURED FOR EXEMPLARY SERVICE
              </span>

              <div className="flex items-center gap-x-2">
                <img
                  src={CALENDER_ICON}
                  className="w-[16px] sm:w-[20px] h-[16px] sm:h-[20px]"
                  alt="Calendar"
                />
                <span className="text-xs font-medium text-globalGreen">
                  2025-05-08
                </span>
              </div>
              <span className="text-xs sm:text-sm font-medium text-gray-regular text-justify leading-relaxed">
                The President of the Enugu State Customary Court of Appeal, Hon.
                Justice George Chibueze Nnamani, FCIArb, was honoured by the
                Enugu State Judiciary for his dedication to upholding justice in
                accordance with the customs and traditions of the people of
                Enugu State. The event highlighted his leadership in ensuring
                timely resolution of appeals and strengthening the
                administration of customary law.
              </span>
              <button className="text-globalGreen text-xs sm:text-sm font-semibold hover:underline transition-all">
                READ MORE
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LastestNews;
